export default "__VITE_ASSET__DucHgOgQ__"